import { useSyncExternalStore } from "react";
import { getSubscriptionState, subscribeSubscriptionState } from "../subscription/subscriptionStore";

export function useSubscriptionState() {
  return useSyncExternalStore(subscribeSubscriptionState, getSubscriptionState, getSubscriptionState);
}
